"use client";
import { useTheme } from "@mui/material/styles";
import { SpaceXs, FontLineHeightLg, FontSize200, FontSize300, FontWeightBold, SpaceSm, SpaceMd } from "@nxt-costco-com/forge-design-tokens";
const commonStyles = {
  alignItems: "flex-start",
  alignSelf: "stretch",
  display: "flex"
};
const LinkListStyle = () => {
  const theme = useTheme();
  return {
    [theme.breakpoints.between("xs", "md")]: {
      h2: {
        ...commonStyles,
        a: {
          "&:hover, &:active": {
            fontWeight: FontWeightBold
          },
          width: "100%"
        },
        fontSize: FontSize200,
        padding: `${SpaceSm} ${SpaceMd}`
      },
      li: {
        ".MuiTypography-root": {
          width: "100%"
        },
        ...commonStyles,
        padding: `${SpaceSm} ${SpaceMd}`
      },
      ul: {
        ...commonStyles,
        flexDirection: "column",
        margin: 0
      }
    },
    h2: {
      fontSize: "20px",
      lineHeight: "1.1"
    },
    li: {
      ".MuiTypography-root": {
        "&:hover, &:active": {
          fontWeight: FontWeightBold
        },
        fontSize: { lg: FontSize300, xs: FontSize200 },
        lineHeight: FontLineHeightLg
      },
      marginBottom: { md: SpaceXs, xs: 0 }
    },
    ul: {
      "& > li:last-child": {
        marginBottom: { lg: SpaceXs, xs: 0 }
      }
    }
  };
};
export {
  LinkListStyle
};
